import React from "react";
import StaticContentPage from "./StaticContentPage";

const DEFAULT_PRIVACY_POLICY_CONTENT = `<p>Last updated: March 15, 2026</p><h2>Introduction</h2><p>TabramEyewear is committed to protecting your privacy. This policy outlines how we collect, use, and protect your personal information.</p><h2>Data Collection</h2><p>We collect information necessary to process your trade account application and fulfill orders, including business details, contact information, and shipping addresses.</p>`;

const PrivacyPolicy = () => {
  return <StaticContentPage title="Privacy Policy" contentKey="privacy_policy_content" fallbackContent={DEFAULT_PRIVACY_POLICY_CONTENT} />;
};

export default PrivacyPolicy;
